// extracted by mini-css-extract-plugin
module.exports = {"border":"Tag_border__NRZ7m","container":"Tag_container__cyUO3","tag":"Tag_tag___AEeN","title":"Tag_title__L4Pc_","listBlock":"Tag_listBlock__KD5dT"};